import React from "react";
import { Typography } from '@progress/kendo-react-common';

/**
 * A theme styled component using Kendo Typography.
 * for more details on (additional) available props. see kendo react api docs.
 *
 * @param {object} props
 * @param {"bold"|"normal"|"light"} props.fontWeight - Font weight option.
 * @param {"center"|"left"|"right"|"justify"} props.textAlign - Text alignment.
 * @param {React.ReactNode} [props.children] - Content inside the paragraph.
 * @returns {JSX.Element}
 *
 * @example
 * <InlineText fontWeight="normal" textAlign="left" style={{your additional styles...}}>
 *   This is some text that will be inline!.
 * </InlineText>
 */

export const InlineText = (props) => {

    return (
        <Typography.p {...props} style={{display: "inline", padding: 0, margin: 0, ...props.style}}>
            {props.children}
        </Typography.p>
    )
};

